import { ITableAvailability } from "../models/IReservation";

/**
 * Grup masanın en az kişi sayısından küçükse ("TooLarge") masa yine seçilebilir:
 * sakin bir akşamda 2 kişiyi 4'lük masaya oturtmak restoranın kararı. Backend de bu
 * durumda kaydı reddetmiyor, panel yalnızca uyarı gösterir.
 */
export function isTableSelectable(t: ITableAvailability): boolean {
  return t.isAvailable || t.unavailableReason === "TooLarge";
}

export function isBelowMinCapacity(t: ITableAvailability): boolean {
  return t.unavailableReason === "TooLarge";
}
